import { render, staticRenderFns } from "./moretable.vue?vue&type=template&id=51fa5988"
import script from "./moretable.vue?vue&type=script&lang=js"
export * from "./moretable.vue?vue&type=script&lang=js"
import style0 from "./moretable.vue?vue&type=style&index=0&id=51fa5988&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports